import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import axios from 'axios';
import Button from '../../components/ui/Button';
import Input from '../../components/ui/Input';
import { formatApiError } from '../../utils/errors';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

export default function AdminForgotPassword() {
  const [loading, setLoading] = useState(false);
  const { register, handleSubmit, formState: { errors } } = useForm();

  const onSubmit = async ({ email }) => {
    setLoading(true);
    try {
      await axios.post(`${API_BASE}/auth/forgot-password`, { email }, { timeout: 20000 });
      toast.success('Check your email for reset instructions.');
    } catch (err) {
      toast.error(formatApiError(err, 'Could not send a reset link. Please try again.'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-brand-600 via-brand-700 to-brand-900 px-4">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-2xl shadow-xl p-8">
          <h2 className="text-xl font-semibold text-gray-900 mb-2">Forgot password</h2>
          <p className="text-sm text-gray-500 mb-6">Enter your staff account email. If it exists, we will send a reset link.</p>
          <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
            <Input
              label="Email"
              type="email"
              autoComplete="email"
              error={errors.email?.message}
              {...register('email', { required: 'Email is required' })}
            />
            <Button type="submit" className="w-full" loading={loading}>Send reset link</Button>
          </form>
        </div>
        <p className="text-center text-brand-200 text-sm mt-6">
          <Link to="/admin/login" className="text-white hover:underline">Back to sign in</Link>
        </p>
      </div>
    </div>
  );
}
